<div (click)="close()" *ngIf="order" class="order-modal-backdrop">
    <article (click)="$event.stopPropagation()" aria-modal="true" class="order-modal" role="dialog">
        <header class="order-modal-header">
            <div><span>{{ 'Order details' | translate }}</span><strong>{{ getOrderIdentifier(order) }}</strong></div>
            <button (click)="close()" [attr.aria-label]="'Close order details' | translate" class="modal-close"
                    type="button">
                <i class="material-icons">close</i>
            </button>
        </header>

        <div class="order-modal-body">
            <div class="details-column">
                <section class="detail-panel">
                    <h2>{{ 'Summary' | translate }}</h2>
                    <div class="detail-grid">
                        <div>
                            <span>{{ 'Status' | translate }}</span><strong>{{ getOrderStatus(order) | translate }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Platform' | translate }}</span><strong>{{ getOrderSource(order) | translate }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Created' | translate }}</span><strong>{{ getEntryDate(order) | date:'dd.MM.yyyy HH:mm:ss' }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Closed' | translate }}</span><strong>{{ getCloseDate(order) | date:'dd.MM.yyyy HH:mm:ss' }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Accepted' | translate }}</span><strong>{{ (getOrderDate(order, 'OrderAcceptedEntryDate') | date:'dd.MM.yyyy HH:mm:ss') || '-' }}</strong>
                        </div>
                        <div>
                            <span>{{ 'First proposal' | translate }}</span><strong>{{ (getOrderDate(order, 'FirstCarProposalDate') | date:'dd.MM.yyyy HH:mm:ss') || '-' }}</strong>
                        </div>
                        <div><span>{{ 'Price' | translate }}</span><strong>{{ getPrice(order) }}</strong></div>
                        <div><span>{{ 'Distance' | translate }}</span><strong>{{ getDistance(order) }}</strong></div>
                        <div><span>{{ 'Billable time' | translate }}</span><strong>{{ getDuration(order) }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Service type' | translate }}</span><strong>{{ getServiceValue(order, 'ServiceType') | translate }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Destination type' | translate }}</span><strong>{{ getServiceValue(order, 'Destination') | translate }}</strong>
                        </div>
                    </div>
                </section>

                <section class="detail-panel">
                    <h2>{{ 'Client and request' | translate }}</h2>
                    <div class="detail-grid">
                        <div><span>{{ 'Name' | translate }}</span><strong>{{ getClientName(order) }}</strong></div>
                        <div><span>{{ 'Phone' | translate }}</span><strong>
                            <a *ngIf="getClientPhone(order) !== '-'" [href]="'tel:' + getClientPhone(order)">
                                {{ getClientPhone(order) }}</a>
                            <ng-container *ngIf="getClientPhone(order) === '-'">-</ng-container>
                        </strong></div>
                        <div><span>{{ 'Email' | translate }}</span><strong>{{ getClientEmail(order) }}</strong></div>
                        <div>
                            <span>{{ 'App version' | translate }}</span><strong>{{ getRequestValue(order, 'AppVer') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Device ID' | translate }}</span><strong>{{ getRequestValue(order, 'DeviceId') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'External order ID' | translate }}</span><strong>{{ getRequestValue(order, 'ExternalSystemOrderId') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Airport order' | translate }}</span><strong>{{ formatBoolean(getRequest(order)?.IsAirportOrder) | translate }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Phone order' | translate }}</span><strong>{{ formatBoolean(getRequest(order)?.IsClassicPhoneOrder) | translate }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Office order' | translate }}</span><strong>{{ formatBoolean(getRequest(order)?.IsOfficeOrder) | translate }}</strong>
                        </div>
                        <div>
                            <span>Drink Safe</span><strong>{{ formatBoolean(getRequest(order)?.IsDrinkSafeOrder) | translate }}</strong>
                        </div>
                    </div>
                </section>

                <section class="detail-panel">
                    <h2>{{ 'Car and driver' | translate }}</h2>
                    <div class="detail-grid">
                        <div><span>{{ 'Assigned car' | translate }}</span><strong>{{ getCarDisplay(order) }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Car identifier' | translate }}</span><strong>{{ getCarValue(order, 'CarIdentifier') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Car number' | translate }}</span><strong>{{ getCarValue(order, 'CarNumber') }}</strong>
                        </div>
                        <div><span>{{ 'Model' | translate }}</span><strong>{{ getCarValue(order, 'CarModel') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Company' | translate }}</span><strong>{{ getCarValue(order, 'CompanyIdentifier') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Driver' | translate }}</span><strong>{{ getDriverValue(order, 'DriverName') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Driver ID' | translate }}</span><strong>{{ getDriverValue(order, 'DriverIdentifier') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Driver phone' | translate }}</span><strong>{{ getDriverValue(order, 'DriverPhone') }}</strong>
                        </div>
                    </div>
                </section>

                <section class="detail-panel">
                    <h2>{{ 'Route' | translate }}</h2>
                    <div class="route-list">
                        <div *ngFor="let point of routePoints"
                             [class.destination]="point.type === 'destination'" [class.pickup]="point.type === 'pickup'"
                             [class.stop]="point.type === 'stop'" class="route-point">
                            <span class="route-point-marker">{{ point.marker }}</span>
                            <div class="route-point-copy">
                                <span>{{ point.label | translate }}</span><strong>{{ point.formattedAddress }}</strong>
                                <small *ngIf="point.address.Comments">{{ point.address.Comments }}</small>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <section class="detail-panel map-panel">
                <div class="map-panel-heading">
                    <h2>{{ 'Map' | translate }}</h2>
                    <span *ngIf="isRouteLoading"><i
                            class="material-icons spinning">refresh</i> {{ 'Loading recorded route' | translate }}</span>
                    <span *ngIf="!isRouteLoading && taximeterPoints.length > 0">
                        {{ taximeterPoints.length }} {{ 'recorded points' | translate }}
                        <ng-container *ngIf="interactiveTaximeterPoints.length < taximeterPoints.length">
                            - {{ interactiveTaximeterPoints.length }} {{ 'interactive' | translate }}
                        </ng-container>
                    </span>
                    <span *ngIf="routeLookupComplete && !isRouteLoading && taximeterPoints.length === 0
                        && routeLoadError === ''">{{ 'No recorded route' | translate }}</span>
                    <span *ngIf="routeLoadError !== ''" class="route-load-error">{{ routeLoadError | translate }}</span>
                </div>
                <div *ngIf="hasMapData()" [class.route-tooltip-open]="isRouteTooltipOpen" class="order-map">
                    <google-map #orderRouteMap (idle)="fitOrderMapBounds()" [center]="mapCenter" [zoom]="mapZoom"
                                height="100%" width="100%">
                        <map-polyline *ngIf="taximeterPoints.length === 0"
                                      [options]="addressPolylineOptions" [path]="mapMarkers">
                        </map-polyline>
                        <map-polyline *ngIf="taximeterPoints.length > 1"
                                      [options]="taximeterPolylineOptions" [path]="taximeterPoints">
                        </map-polyline>
                        <map-marker #routeMapMarker
                                    (mapClick)="openOrderMarkerInfo(routeMapMarker, marker)"
                                    *ngFor="let marker of mapMarkers"
                                    [label]="marker.labelOptions" [options]="marker.options"
                                    [position]="marker.position">
                        </map-marker>
                        <map-info-window #routeMarkerInfo>
                            <strong *ngIf="selectedMapMarker">{{ selectedMapMarker.title | translate }}</strong>
                        </map-info-window>
                        <map-marker #routePointMarker
                                    (mapMouseout)="hideRoutePointInfo()"
                                    (mapMouseover)="showRoutePointInfo(routePointMarker, point)"
                                    *ngFor="let point of interactiveTaximeterPoints"
                                    [label]="point.labelOptions" [options]="point.options"
                                    [position]="point.position">
                        </map-marker>
                        <map-info-window #routePointInfo [options]="routePointInfoOptions">
                            <div *ngIf="selectedRoutePoint" class="taximeter-point-info">
                                <strong *ngIf="selectedRoutePoint.isFallbackDestination">
                                    {{ 'Destination' | translate }}
                                </strong>
                                <strong>{{ selectedRoutePoint.localTimestamp | date:'dd.MM.yyyy HH:mm:ss' }}</strong>
                                <span>{{ 'Speed' | translate }}:
                                    {{ formatRouteSpeed(selectedRoutePoint.speed) }}</span>
                            </div>
                        </map-info-window>
                    </google-map>
                </div>
                <div *ngIf="!hasMapData()" class="map-empty">
                    <i class="material-icons">location_off</i><span>{{ 'No route coordinates are stored for this order.' | translate }}</span>
                </div>
            </section>
        </div>
    </article>
</div>
